/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  // Input,
  Modal,
  Input,
  TreeSelect,
} from 'antd';
// import { CheckCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
// import makeTree from 'utils/makeTree';
import {
  CRUDclavePresupuestalEgresosConceptosDeEgreso, extractIdsCog, makeTreeCog,
  ModelClavesPresupuestalesDeIngresoConceptosDeEgreso, normalizeCog,
  URIclavePresupuestalEgresosConceptosDeEgresoPut,
} from 'api/configuraciones/clavesPresupuestalesDeEgresos';
import { findInTree } from 'api/configuraciones/clavesPresupuestalesDeIngresos';
import { getClasificadoresObjetoGastoUnion } from 'api/configuraciones/clasificadorObjetoGasto';

const ClavePresupuestalEgresosConceptosDeEgreso = ({
  fatherID,
  permission,
  disableFieldsParent,
}) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [cogs, setCogs] = useState([]);
  const [disableFields, setDisableFields] = useState(false);

  const registroName = `${selectedData?.configurar_guardias_vacacionales
    ?.periodos_vacacionales?.periodo}`;
  const cliente = CRUDclavePresupuestalEgresosConceptosDeEgreso;
  // const clienteModal = CRUDclavePresupuestalIngresosConceptosDeIngreso;
  const {
    nameModel,
    nameModelSingular,
  } = ModelClavesPresupuestalesDeIngresoConceptosDeEgreso;

  const formInstances = [
    form,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await cliente.obtenerListaDeRegistros(
      { clave_presupuestal_egresos: fatherID[0] },
    );
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
        _cogs,
      ] = await Promise.all([
        cliente.obtenerListaDeRegistros(
          { clave_presupuestal_egresos: fatherID[0] },
        ),
        getClasificadoresObjetoGastoUnion(),
      ]);
      if (mounted) {
        setData(formatReceived(_data));
        const cogsFormatted = normalizeCog(makeTreeCog(_cogs));
        setCogs(cogsFormatted);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _nivelDeEstudio = await cliente.obtenerUnRegistro(match.id);
    _nivelDeEstudio.clasificador_de_objeto_de_gasto = findInTree(
      cogs,
      _nivelDeEstudio.clasificador_de_objeto_de_gasto,
    ).value;
    setTimeout(() => {
      if (_nivelDeEstudio) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(_nivelDeEstudio));
          setDisableFields(
            _nivelDeEstudio?.estados_globales !== ESTATUS_ACTIVO
            || disableFieldsParent,
          );
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      let saved;
      if (key) {
        values.clasificador_de_objeto_de_gasto = extractIdsCog(
          values?.clasificador_de_objeto_de_gasto,
        );
        saved = await cliente.actualizarRegistro(key, values);
      } else {
        const { clasificador_de_objeto_de_gasto } = values;
        const payloadConcepto = clasificador_de_objeto_de_gasto.map((_cog) => ({
          id: parseInt(extractIdsCog(
            _cog,
          ), 10),
        }));
        saved = await cliente.reemplazarRegistro(
          fatherID,
          payloadConcepto,
          URIclavePresupuestalEgresosConceptosDeEgresoPut,
        );
      }
      if (saved) {
        handleOnRowClick(saved);
        onCancel();
        await fetchData();
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await cliente.borrarRegistro(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // const handleKeyPress = (e) => {
  //   if (/\d/.test(e.key)) {
  //     e.preventDefault();
  //   }
  // };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Nivel de Estudios ya autorizado');
        return;
      }
      const saved = await cliente.autorizarRegistro(key);
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Clasificador por Objeto del Gasto',
      dataIndex: 'clasificador_de_objeto_de_gasto',
      key: 'clasificador_de_objeto_de_gasto',
      render: (val) => {
        const found = findInTree(cogs, val);
        return found ? found.title : val;
      },
      width: 300,
    },
  ];
  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          // customActions={[
          //   {
          //     onClick: () => setVisibleAutorizar(true),
          //     icon: <CheckCircleOutlined />,
          //     text: 'Autorizar',
          //     disabledBySelection: true,
          //     disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
          //     className: 'success',
          //   },
          // ]}
          disableDelete={
            selectedData?.estados_globales === ESTATUS_AUTORIZADO
            || disableFieldsParent
          }
          disableAdd={
            disableFieldsParent
          }
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          width="90%"
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} ${nameModel}`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
            }}
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={24}>
                <Form.Item
                  name="clasificador_de_objeto_de_gasto" // OJO: Este campo ahora guardará la CLAVE ("1111")
                  label="Clasificador por Objeto del Gasto (COG)"
                  rules={[{ required: true, message: 'Seleccione el Clasificador por Objeto del Gasto' }]}
                  hasFeedback
                >
                  <TreeSelect
                    showSearch
                    treeNodeFilterProp="title"
                    multiple={!selectedRowKeys.length}
                    treeData={cogs}
                    disabled={disableFields}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="clave_presupuestal_egresos"
                  label="Padre"
                  hasFeedback
                  hidden
                  initialValue={fatherID[0]}
                >
                  <Input
                    hidden
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Row>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`${nameModelSingular} ${registroName}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle={`Autorizar ${nameModelSingular} ${registroName}`}
          open={visibleAutorizar}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={() => setVisibleConfirmInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleConfirmInactivo(false);
          }}
          open={visibleConfirmInactivo}
          contentTitle={`Inactivar ${nameModelSingular} ${registroName}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default ClavePresupuestalEgresosConceptosDeEgreso;
